import { render, staticRenderFns } from "./FranchisorWelcomeBanner.vue?vue&type=template&id=6cacf5e0&scoped=true&"
import script from "./FranchisorWelcomeBanner.vue?vue&type=script&lang=js&"
export * from "./FranchisorWelcomeBanner.vue?vue&type=script&lang=js&"
import style0 from "./FranchisorWelcomeBanner.vue?vue&type=style&index=0&id=6cacf5e0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cacf5e0",
  null
  
)

export default component.exports